import { FoodsIconButton } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { t } from "i18next";
import { EngagedActTypo } from "src/components/Actions/Common/EngagedActTypo";
import { useCatalogContext } from "../context/useCatalogContext";

export const SummaryHeader = () => {
    const theme = useTheme();
    const { catalogView, setCatalogView, actionsByParents } = useCatalogContext();

    return (
        <Stack justifyContent={"space-between"} flexDirection={"row"}>
            <Stack flexDirection={"row"} alignItems={"center"}>
                <EngagedActTypo
                    engagedActions={actionsByParents.engagedActions}
                    totalActions={actionsByParents.totalActions}
                />
            </Stack>
            <Stack>
                <FoodsIconButton
                    withBackground
                    size={"s"}
                    icon={catalogView === "list" ? "gridView" : "formatNumberedList"}
                    buttonProps={{
                        onClick: () => {
                            if (catalogView === "grid") {
                                setCatalogView("list");
                            } else if (catalogView === "list") {
                                setCatalogView("grid");
                            }
                        },
                    }}
                    tooltip={{
                        text:
                            catalogView === "grid" ?
                                t("action_plan.catalog.switch_to_list", "Switch to list")
                            :   t("action_plan.catalog.switch_to_grid", "Switch to grid"),
                    }}
                />
            </Stack>
        </Stack>
    );
};
